var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChicken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.5 47.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd983",
    d: "M0 0l-5.844 5.844a2.582 2.582 0 01-3.812 3.479 2.585 2.585 0 01-.715-2.282 2.585 2.585 0 01-2.282-.716 2.59 2.59 0 010-3.662 2.58 2.58 0 013.479-.149L-3.33-3.33 0 0z",
    transform: "translate(15.017 26.632)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1694f",
    d: "M0 0c1.665 1.665 5.874 8.81.046 14.636-4.059 4.058-7.328 3.826-13.416 5.335-2.497.832-5.752 3.832-6.584 4.665-.833-.833-.542-3.874-.542-3.874s-3.626-.294-4.458-1.126c.832-.833 4.699-4.49 5.375-6.207 1.821-5.775 1.613-8.711 5.671-12.77C-7.248-6-1.664-1.664 0 0",
    transform: "translate(33.954 4.364)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChicken);
export default __webpack_public_path__ + "static/media/Chicken.a917ef90325abde078252194395708ac.svg";
export { ForwardRef as ReactComponent };